// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_eGQ","cls2":"ClaimsList-cls2_50r ClaimsList-cls1_eGQ"};